import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UserSettingsContext } from "../../../setup/routes-manager/RequireAuth";
import FreeToolSteelCard from "./free_tool_steel_card";
import { getFreeToolSteelCardKey } from "./free_tool_steel_card_config";

/**
 * Renders the steel card when the current route matches tool_cards_popup from /chart/mp.
 */
export default function FreeToolSteelCardHost() {
    const { pathname } = useLocation();
    const routeToolKey = getFreeToolSteelCardKey(pathname);
    const { steelCardTool } = useContext(UserSettingsContext);
    
    // routeToolKey means basically mp or vol etc 
    // we are comparing it and steelCardTool because it can lead to showing opt card in the mp chart so it compares this parameter and make sure that route and steel card matches
    if (!routeToolKey || !steelCardTool || routeToolKey !== steelCardTool) {
        return null;
    }

    return <FreeToolSteelCard key={routeToolKey} toolKey={routeToolKey} />;
}
